import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

// import empty from "../../Assets/Projects/project_empty.png";
import eMesh from "../../Assets/Projects/eMesh.png";
import Voronoi from "../../Assets/Projects/Voronoi.png";
import Pokemon from "../../Assets/Projects/pokemon.png";
import BlueSafe from "../../Assets/Projects/blue-safe.png";
import GoTask from "../../Assets/Projects/gotask.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Projects </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few of my  projects
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={eMesh}
              isGh={true}
              // second={true}
              isPhone=""
              title="Password-Checker Using python"
              label_1="Github"
              // label_2=" DevPost"
              description="This is the basic project which tell whether the password you are using is safe or not and it also tells how many times the password you are using has been cracked"
              link_1="https://github.com/G8ur/Password-Checker-using-apis.git"
              // link_2="https://devpost.com/software/emesh-io"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Voronoi}
              isBlog={false}
              isGh={true}
              label_1="Github"
              title="Scrapping data from Website"
              description="Basic script that scraps data from website using beautiful soup. The website from which data is being scrapped in this case is hacker rank. Note:-If using other website be sure to change the div class according to website classname"
              link_1="https://github.com/G8ur/Scrapping-Data-from-Website.git"
            // link_2=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Pokemon}
              isGh={true}
              isBlog={false}
              title="DinoRio"
              label_1="Github"
              description="It is a basic 2d game created using pygame library and it has 8 levels . We will be adding more levels in future. The character used in free to use from 2d game art. It's mechanism is like mario"
              link_1="https://github.com/G8ur/Dinorio.git"
            // link_2=""              
            />
          </Col>

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={GoTask}
              isBlog={false}
              title="GoTask"
              description="Collaborated with the Company OnTask to use their eSignature and Automated Workflows into an easy to use and appealing Google Chrome extension. This was so that their functionality can be used without leaving the comfort of your Google Docs or Sheet to start your workflow with that document. This was programmed by a team and I using Axios, Javascript, and HTML, in an Agile setting."
            // link_1=""
            // link_2=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={BlueSafe}
              isBlog={true}
              isGh={true}
              second={true}
              title="BlueSafe"
              label_1="Github"
              label_2=" Devpost"
              description="Created a safety app to help increase safety of walks, specifically those alone. Features include contacting authorities, emergency contacts, and pinging your location to them when desired. Programmed using React Native, Android Studio, ExpressJS and Typescript."
              link_1="https://github.com/sethgaglione/hackabull-2021-frontend"
              link_2="https://devpost.com/software/blue-safe"
            />
          </Col> */}

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={empty}
              isBlog={false}
              title="CO2-Aversion"
              description=""
              // link_1=""
              // link_2=""
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
